import { addDays } from "date-fns";
import React from "react";

import { faInfoCircle } from "@performyard/fontawesome/pro-regular-svg-icons";
import {
	Alert,
	FormDatePicker,
	FormSubscribe,
	InputText,
	InputWrapper,
	Text,
	usePyForm,
} from "@performyard/py-components";

import { COMPENSATION_CYCLE_NAME_MAX_LENGTH } from "../types";

import { useCompanySettings } from "../../../../api/hooks/defs/company";

const CycleNameField = () => {
	const form = usePyForm();

	return (
		<form.Field<string> name="name" mode="value">
			{(field) => {
				const errors = (field.state.meta.errors as { message: string }[] | undefined) ?? [];
				const { value, meta } = field.state;
				const isTouched = meta.isTouched;
				const isEmpty = value.trim() === "";
				const isTooLong = value.length > COMPENSATION_CYCLE_NAME_MAX_LENGTH;
				const errorMessage = isTooLong
					? `Cycle name must be ${COMPENSATION_CYCLE_NAME_MAX_LENGTH} characters or fewer`
					: isTouched && isEmpty
						? "Cycle name is required"
						: errors[0]?.message;

				return (
					<InputWrapper id={field.name} label="Compensation Cycle Name" error={errorMessage}>
						<InputText
							id={field.name}
							value={field.state.value}
							onChange={field.handleChange}
							onBlur={field.handleBlur}
							placeholder="Compensation cycle name"
							errored={Boolean(errorMessage)}
						/>
					</InputWrapper>
				);
			}}
		</form.Field>
	);
};

const CycleDetailsStep = () => {
	const { data: companySettings } = useCompanySettings();

	const timeZone = companySettings?.default_timezone || "America/Eastern";

	return (
		<div className="mx-auto flex max-w-[512px] flex-col gap-8">
			<div className="text-center">
				<Text size="sub-heading" weight="semi-bold">
					Create a Compensation Cycle
				</Text>
				<Text size="paragraph-2" weight="regular">
					Cycle Details
				</Text>
			</div>
			<div>
				<CycleNameField />
				<div className="mb-2 mt-4 grid grid-cols-2 gap-2">
					<FormDatePicker id="startDate" label="Start Date" />
					<FormSubscribe
						id="dueDate_subscription"
						selector={(state: { values: { startDate: Date | null } }) => state.values.startDate}
					>
						{(startDate) => (
							<FormDatePicker
								startDate={startDate ? addDays(startDate, 1) : undefined}
								id="dueDate"
								label="Due Date"
							/>
						)}
					</FormSubscribe>
				</div>
				<Alert
					message={`All dates are set to your company timezone  ${timeZone}`}
					type="neutral"
					icon={faInfoCircle}
				/>
			</div>
		</div>
	);
};

export default CycleDetailsStep;
